import api from "./api";

export interface JoinWaitingQueueProps {
  email: string;
  loginMethod: 1 | 2;
}

interface JoinWaitingQueueParams {
  name: string;
  email: string;
  login_method: 1 | 2;
}

export const joinWaitingQueue = (props: JoinWaitingQueueProps) => {
  const params: JoinWaitingQueueParams = {
    name: "",
    email: props.email,
    login_method: props.loginMethod,
  };
  return api.post<unknown>("/join-waiting-queue", params);
};
